import { type } from '../../util/util';
import { Action } from '@ngrx/store';

import * as commonTypes from '../../../shared/types';

export const ActionTypes = {
    ENABLE_BUSY_FLAG: type('[Container Application] ENABLE_BUSY_FLAG'),
    DISABLE_BUSY_FLAG: type('[Container Application] DISABLE_BUSY_FLAG'),
    RESET_NOTIFICATION: type('[Container Notification] Reset Notifications'),
    POP_NOTIFICATION:  type('[Container Notification] Pop Notification'),
    POP_NOTIFICATION_SUCCESS: type('[Container Notification] Pop Notification Success'),
    LOAD_PORTAL_INFO:  type('[Application] Load Portal Info'),
    LOAD_PORTAL_INFO_SUCCESS: type('[Application] Load Portal Info Success'),
    LOAD_PORTAL_INFO_FAIL: type('[Application] Load Portal Info Failure'),
    APP_CHECK_VERSION: type('[Application] Check new version'),
    APP_UPDATE_VERSION: type('[Application] Update to the new version'),
    APP_RECEIVED_VERSION: type('[Application] Received new version')
};

export class EnableBusyFlag implements Action {
    readonly type = ActionTypes.ENABLE_BUSY_FLAG;

    public constructor(public payload: any) {
    }
}

export class DisableBusyFlag implements Action {
    readonly type = ActionTypes.DISABLE_BUSY_FLAG;

    public constructor(public payload: any) {
    }
}

export class PopNotificationAction implements Action {
  readonly type = ActionTypes.POP_NOTIFICATION;

  public constructor(public payload: commonTypes.IToastr) { }
}

export class ResetPopNotificationAction implements Action {
  readonly type = ActionTypes.RESET_NOTIFICATION;

  public constructor(public payload: any) { }
}

export class PopNotificationSuccessAction implements Action {
  readonly type = ActionTypes.POP_NOTIFICATION_SUCCESS;

  public constructor(public payload: commonTypes.IToastr) { }
}

export class LoadPortalInformationAction implements Action {
  readonly type = ActionTypes.LOAD_PORTAL_INFO;

  public constructor(public payload: any) { }
}

export class LoadPortalInformationSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_PORTAL_INFO_SUCCESS;

  public constructor(public payload: commonTypes.IPortalInfo) { }
}

export class LoadPortalInformationFailureAction implements Action {
  readonly type = ActionTypes.LOAD_PORTAL_INFO_FAIL;

  public constructor(public payload: commonTypes.IErrorResponse<{}>) { }
}

export class ApplicationVersionReceivedAction implements Action {
  readonly type = ActionTypes.APP_RECEIVED_VERSION;

  public constructor(public payload: any) { }
}

export class ApplicationCheckVersionAction implements Action {
  readonly type = ActionTypes.APP_CHECK_VERSION;

  public constructor(public payload: any) { }
}

export class ApplicationUpdateVersionAction implements Action {
  readonly type = ActionTypes.APP_UPDATE_VERSION;

  public constructor(public payload: any) { }
}

export type Actions
    = EnableBusyFlag | DisableBusyFlag
    | ResetPopNotificationAction
    | LoadPortalInformationAction | LoadPortalInformationSuccessAction | LoadPortalInformationFailureAction
    | PopNotificationAction | PopNotificationSuccessAction
    | ApplicationVersionReceivedAction | ApplicationCheckVersionAction | ApplicationUpdateVersionAction;




// WEBPACK FOOTER //
// ./src/app/stateManagement/actions/containers/application.ts